import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const parseLocation = (lat, long) => {
  const latitude = parseFloat(lat);
  const longitude = parseFloat(long);

  if (
    !isNaN(latitude) &&
    !isNaN(longitude) &&
    latitude >= -90 &&
    latitude <= 90 &&
    longitude >= -180 &&
    longitude <= 180
  ) {
    return { latitude, longitude };
  }

  console.warn("Invalid latitude or longitude:", { lat, long });
  return null;
};

// const ScrollToTop = () => {
//   const { pathname } = useLocation();

//   useEffect(() => {
//     console.log("ScrollToTop fired for", pathname);
//     // Try both window and document scrolling for better compatibility
//     window.scrollTo({
//       top: 0,
//       left: 0,
//       behavior: "instant" // Using instant instead of smooth for immediate effect
//     });

//     // Backup method using document
//     if (document.documentElement) {
//       document.documentElement.scrollTop = 0;
//     }
//   }, [pathname]);

//   return null;
// };

export { parseLocation };
